import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useQuery } from "react-query";
import LoadingApiQuery from "../../../components/LoadingApiQuery";
import axiosClient from "../../../lib/axios";
import { useMemo, useState } from "react";
import EditIcon from '@mui/icons-material/Edit';
import DisplayNotFoundInfo from "../../../components/DisplayNotFindInfo";
import DialogCriacaoEditCopyNorte from "./DialogCriacaoEditCopyNorte";

export default function CopyNorteConfig() {

    const [openDialogEditar, setOpenDialogEditar] = useState<TFormEnvioConfigCopyNorteIds | null>(null)

    //Querys e Mutations
    const { data, isLoading: isLoadingConfiguracoes } = useQuery({
        queryKey: ["pesquisar-configuracoes-copy-norte"],
        queryFn: () => axiosClient.get("/configuracoes", {
            params: {
                chave: 'copy_norte'
            }
        })
    });

    const dataConfigCopyNorte: TConfigCopyNorteIds | null = useMemo(() => {
        // Se não vier nada retorna null;
        if (!data?.data) return null;
        return data.data;
    }, [data]);

    return (
        <>
            <Typography mb={3} variant="h6">Integração Copy Norte</Typography>
            {
                isLoadingConfiguracoes &&
                <LoadingApiQuery />
            }
            {
                (!isLoadingConfiguracoes && !dataConfigCopyNorte) &&
                <DisplayNotFoundInfo label="Nenhuma integração encontrada" />
            }

            {(!isLoadingConfiguracoes && dataConfigCopyNorte) && (
                <>
                    <TableContainer>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell><b>Nome</b></TableCell>
                                    <TableCell ><b>Id</b></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    Object.entries(dataConfigCopyNorte as TConfigCopyNorteIds).map(([chave, valor]) => {
                                        const titulo = chave.replace(/_/g, " ").replace(/\b\w/g, letra => letra.toUpperCase());

                                        return (
                                            <TableRow
                                                key={chave}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    {titulo}
                                                </TableCell>
                                                <TableCell>
                                                    {valor}
                                                </TableCell>
                                                <TableCell>
                                                    <Box display="flex" alignItems="center" justifyContent="flex-end">
                                                        <IconButton aria-label="edit" onClick={() => setOpenDialogEditar({
                                                            chave,
                                                            valor
                                                        })}>
                                                            <EditIcon />
                                                        </IconButton>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {
                        Boolean(openDialogEditar) &&
                        <DialogCriacaoEditCopyNorte
                            open={Boolean(openDialogEditar)}
                            handleClose={() => setOpenDialogEditar(null)}
                            defaultValue={openDialogEditar}
                            dataDefault={dataConfigCopyNorte}
                        />
                    }
                </>
            )}

        </>
    )
}

export type TConfigCopyNorteIds = {
    PESSOA_FISICA_PASTA_ID: string;
    PESSOA_JURIDICA_PASTA_ID: string;
    TESTE_PASTA_ID: string;
}

export type TFormEnvioConfigCopyNorteIds = {
    chave: string;
    valor: string;
}
